import React, { useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import {
  GetAll,
  Delete
} from "adminApi/ItemsUnitApi/ItemsUnit";
import DataTable from "Common/DataTable/DataTable";
import useDebouncedValue from "Common/DataTable/useDebouncedValue";
import usePaginatedFetch from "Hooks/usePaginatedFetch";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import feilds from "../../json/ItemsUnitFields.json";
import { FilterStatus } from "utils/FilterStatus";

const ItemsUnitListTable = () => {
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const debouncedSearch = useDebouncedValue(search, 500);
  const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
  const sizeOptions = [10, 20, 50, 100];
  const { tabledata } = feilds
  // Fetch Hook
  const { data, meta, loading, error, refetch } = usePaginatedFetch(GetAll, {
    page,
    limit,
    search: debouncedSearch,
    title: "Items Unit",
  });

  const displayFields = generateDisplayFields(tabledata);

  // filter data
  const filteredData = FilterStatus(data);

  // Table Hook
  const { formattedData, columns } = useTableConfig({
    data: filteredData,
    page,
    limit,
    canShowAction,
    refetch,
    config: {
      entityName: "Items Unit",
      editUrl: "edit-unit-items",
      idKey: "id",
      deleteApi: Delete,
      displayFields,
    },
  });

  const handleSearch = (val, resetPage = null) => {
    setSearch(val);
    if (resetPage !== null) setPage(resetPage);
  };

  const onPageChange = (p) => setPage(p);
  
  const onLimitChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1);
  };

  return (
    <DataTable
      columns={columns}
      data={formattedData}
      options={{
        loading,
        error,
        sortableColumns: displayFields.map((f) => f.accessor),
        copy: true,
        csv: true,
        pdf: true,
        print: true,
        fileName: "Items Unit",
      }}
      Search={{
        search: true,
        SearchInputValue: search,
        handleSearch: handleSearch,
      }}
      Entries={{
        Entries: true,
        limit,
        onLimitChange,
        options: sizeOptions,
      }}
      pagination={{
        isActive: true,
        meta,
        onPageChange,
      }}
    />
  );
};

export default ItemsUnitListTable;
